import React, { Fragment } from 'react'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import ProcessedOrders from '../components/orders/ProcessedOrders'
import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'

function OrderProcessedPage(props) {
  return (
    <Fragment>
        <div className='Desktop'>
          <NavMenuDesktop user={props.user} />
        </div>
        <div className='Mobile'>
        <NavMenuMobile />
        </div>
      
        <ProcessedOrders user={props.user}/>
        
        <div className='Desktop'>
        <FooterDesktop />
        </div>

        <div className='Mobile'>
          <FooterMobile />
        </div>
      </Fragment>
  )
}

export default OrderProcessedPage
